import { UpdateGroupRequest } from '@/types/api/group/request';
import { z, ZodSchema } from 'zod';
import { NameSchema } from '../shared/utility/name.schema';
import { GroupType } from '@/types/api/group';

export const UpdateGroupSchema: ZodSchema<UpdateGroupRequest> = z.object({
  groupName: NameSchema,
  organizationName: NameSchema,
  groupType: z.nativeEnum(GroupType),
});
